import { Button } from 'antd';

type Props = {
  disabled?: boolean;
  loading?: boolean;
  onExport?: () => void;
};

export const GhePage4ExportButton = ({ disabled, loading, onExport }: Props) => {
  return (
    <Button
      type="primary"
      disabled={disabled}
      loading={loading}
      onClick={onExport}
      data-testid="ghe-page4-export-button"
    >
      Download Excel
    </Button>
  );
};
